


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GroupMemberView extends Vue {
  public items: Common.GroupMember[] = new Array();
  public params: Common.GroupMemberQuery = new Common.GroupMemberQuery();
  public importQuery = new Common.ImportQuery('グループメンバ', 'GroupMember');
  public exportQuery = new Common.ExportQuery('グループメンバ', this.params);

  public sortOptions: any = [
    { value: 'groupId', text: 'グループID' },
    { value: 'userId', text: 'ユーザーID' },
  ];
}
